function PrintControls() {
    this.PrintMap = null;
    this.SecondPrintMap = null;
    this.ArrayPrintMap = [];
    this.SelectedTrackPoint = '';
    this.ArrayPrintAssociationMap = [];
}
if (typeof exports !== 'undefined') {
    module.exports = PrintControls;
}